export function ReviewsStars({ stars }) {
  return (
    <span className="text-primary-500">
      {[1, 2, 3, 4, 5].map((star) => (
        <i
          key={star}
          className={`${
            stars >= star
              ? 'icon-star_fill_small'
              : stars >= star - 0.5
              ? 'icon-star_half_fill_small'
              : 'icon-star_empty_small'
          }`}
          aria-hidden="true"
        />
      ))}
    </span>
  );
}
